import React from 'react';
import styled from '@emotion/styled';
import { layout } from '@modernhealth/vital-foundation';

const Container = styled.div({
    display: 'flex',
    alignItems: 'flex-start',
    alignSelf: 'center',
    width: '100%',
    maxWidth: layout.containerWidth,
    flexDirection: 'column',
    paddingLeft: layout.containerPaddingX,
    paddingRight: layout.containerPaddingX,
    paddingBottom: layout.footerHeight,
    paddingTop: 30,
});

const BaseContent = styled.div({
    display: 'flex',
    flexDirection: 'column',
});

const CenteredContent = styled(BaseContent)({
    alignSelf: 'center',
});

const Header: React.FC = ({ children }) => <>{children}</>;

const Content: React.FC<{
    centered?: boolean;
    alignChildren?: 'center' | 'start';
    className?: string;
}> = ({ centered, children, className, alignChildren }) => {
    if (centered) {
        return (
            <CenteredContent
                className={className}
                style={{ alignItems: alignChildren === 'center' ? 'center' : 'flex-start' }}
            >
                {children}
            </CenteredContent>
        );
    }

    return (
        <div
            className={className}
            style={{ alignItems: alignChildren === 'center' ? 'center' : 'flex-start' }}
        >
            {children}
        </div>
    );
};

export const Page = {
    Container,
    Header,
    Content,
};
